module.exports = __webpack_public_path__ + "static/media/background.2603b55a.jpg";